import api from "../helpers/axios";

export const checkSSOLogin = async (email) => {
    try {
        const url = `/auth/check-sso`;
        const response = await api.post(url, { email });
        return response?.data;
    } catch (error) {
        console.error("Error checkSSOLogin:", error);
        throw error;
    }
};

export const fetchUserProfile = async () => {
    try {
        const url = `/users/me`;
        const response = await api.get(url);
        return response?.data;
    } catch (error) {
        console.error("Error fetching user profile:", error);
        throw error;
    }

}